import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { getContainingView } from '@jbrowse/core/util';
import { observer } from 'mobx-react';
import { ContentBlock, ElidedBlock, InterRegionPaddingBlock } from '@jbrowse/core/util/blockTypes';
import { ContentBlock as ContentBlockComponent, ElidedBlock as ElidedBlockComponent, InterRegionPaddingBlock as InterRegionPaddingBlockComponent } from './Block';
var useStyles = makeStyles()({
  linearBlocks: {
    whiteSpace: 'nowrap',
    textAlign: 'left',
    position: 'absolute',
    minHeight: '100%',
    display: 'flex'
  },
  heightOverflowed: {
    position: 'absolute',
    color: 'rgb(77,77,77)',
    borderBottom: '2px solid rgb(77,77,77)',
    textShadow: 'white 0px 0px 1px',
    whiteSpace: 'nowrap',
    width: '100%',
    fontWeight: 'bold',
    textAlign: 'center',
    zIndex: 2000,
    boxSizing: 'border-box'
  }
});
var RenderedBlocks = observer(function (_ref) {
  var model = _ref.model;
  var _useStyles = useStyles(),
    classes = _useStyles.classes;
  var blockDefinitions = model.blockDefinitions,
    blockState = model.blockState;
  return React.createElement(React.Fragment, null, blockDefinitions.map(function (block) {
    if (block instanceof ContentBlock) {
      var state = blockState.get(block.key);
      return React.createElement(ContentBlockComponent, {
        block: block,
        key: "".concat(model.id, "-").concat(block.key)
      }, state && state.ReactComponent ? React.createElement(state.ReactComponent, {
        model: state
      }) : null, state && state.maxHeightReached ? React.createElement("div", {
        className: classes.heightOverflowed,
        style: {
          top: state.layout.getTotalHeight() - 16,
          pointerEvents: 'none',
          height: 16
        }
      }, "Max height reached") : null);
    }
    if (block instanceof ElidedBlock) {
      return React.createElement(ElidedBlockComponent, {
        key: "".concat(model.id, "-").concat(block.key),
        width: block.widthPx
      });
    }
    if (block instanceof InterRegionPaddingBlock) {
      return React.createElement(InterRegionPaddingBlockComponent, {
        key: block.key,
        width: block.widthPx,
        style: {
          background: 'none'
        },
        boundary: block.variant === 'boundary'
      });
    }
    throw new Error("invalid block type ".concat(typeof block));
  }));
});
function LinearBlocks(_ref2) {
  var model = _ref2.model;
  var _useStyles2 = useStyles(),
    classes = _useStyles2.classes;
  var blockDefinitions = model.blockDefinitions;
  var viewModel = getContainingView(model);
  return React.createElement("div", {
    className: classes.linearBlocks,
    style: {
      left: blockDefinitions.offsetPx - viewModel.offsetPx
    }
  }, React.createElement(RenderedBlocks, {
    model: model
  }));
}
export { RenderedBlocks, useStyles };
export default observer(LinearBlocks);